<mat-form-field [appearance]="options?.appearance? options.appearance : 'standard'">
    <mat-label>{{options.title}}<span class="asterisk"
            *ngIf="utils.isRequiredField(formControlUserClient)">*</span></mat-label>
    <input (keyup)="changeValue()" matInput [matAutocomplete]="autocompleteUsersClient"
        [formControl]="formControlUserClient">
    <div matSuffix class="spinner-border text-info" role="status" *ngIf="loadingUsers">
        <span class="sr-only">Loading...</span>
    </div>
    <mat-autocomplete #autocompleteUsersClient="matAutocomplete" [displayWith]="displayUserClientName"
        (optionSelected)="onSelectUserClient($event)">
        <mat-option *ngFor="let userClient of usersClientFiltered" [value]="userClient">
            <span *ngIf="userClient.information?.name" class="mr-2">
                <strong>{{userClient.information.name}}</strong>
            </span>
            <span *ngIf="userClient.information?.document">
                ({{userClient.information.document}})
            </span>
        </mat-option>
    </mat-autocomplete>
    <i *ngIf="options?.showXMark && formControlUserClient?.value?.information?.document" matSuffix
        class="fas fa-times-circle cursor-pointer" matTooltip="Borrar" (click)="cleanFieldUserClient()"></i>
    <mat-error *ngIf="formControlUserClient.errors?.required">
        {{ utils.giveMessageError('MANDATORY_FIELD') }}
    </mat-error>
</mat-form-field>